import { Prop, Vue } from 'vue-property-decorator'

export class TimelineBase extends Vue {
  @Prop() readonly value!: any
  @Prop({ type: String }) readonly label!: string
}
